import { useMutation, gql } from "@apollo/client";
import React, { useState } from "react";
import { Button, Confirm } from "semantic-ui-react";
import Swal from "sweetalert2";

const DeleteModule = ({ id, reload }) => {
  const [open, setOpen] = useState(false);

  const onCompleted = async () => {
    await reload();
    Swal.fire({
      icon: 'success',
      title: 'Completado',
      text: 'Se ha eliminado el módulo de manera exitosa.'
    }).then(() => setOpen(false));
  };

  const onError = ({ graphQLErrors }) => {
    setOpen(false);
    if (graphQLErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: graphQLErrors[0]?.message
      });
    } else {
      Swal.fire("Lo sentimos, ha ocurrido un error.");
    }
  };

  const [mutation] = useMutation(DELETE_MODULE, { onCompleted, onError });
  const handleMutation = () => {
    mutation({ variables: { id } });
  }
  return (
    <div>
      <Button content="Eliminar" icon="delete" onClick={() => setOpen(true)} />
      <Confirm
        size="tiny"
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={open}
        content='Desea eliminar este modulo?'
        onCancel={() => setOpen(false)}
        onConfirm={handleMutation}
      />
    </div>
  );
};

const DELETE_MODULE = gql`
  mutation eliminarModulo($id: ID!) {
    eliminarMultiModulo(id: $id)
  }
`;

export default DeleteModule;